import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ProductConfiguration } from '../products/productConfiguration';
import { CreateQuoteStep1 } from './otherQuoteEntities';
import { Spinner } from '@ami/react/core';
import { Button } from 'reactstrap';
import QuoteWizardContext from '../quotes/QuoteWizardContext';
//import './InnerStepHeader.scss';

export default class InnerStepHeader extends React.PureComponent {
  static propTypes = {
    step1: PropTypes.instanceOf(CreateQuoteStep1).isRequired,
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
    onContinue: PropTypes.func,
    preparingForReview: PropTypes.bool,
    isAmiPriceLookupMode: PropTypes.bool,
    showHeaderActions: PropTypes.bool,
    isFromStep3: PropTypes.bool,
  };
  static contextType = QuoteWizardContext;
  static defaultProps = {
    preparingForReview: false,
    isAmiPriceLookupMode: false,
    showHeaderActions: true,
    isFromStep3: false,
  };

  render() {
    const {
      step1,
      preparingForReview,
      isAmiPriceLookupMode,
      showHeaderActions,
      isFromStep3,
    } = this.props;
    return (
      <div className="quote-step3-header">
        <div className="container">
          <div className="flextable">
            <div className="flextable-item flextable-primary header-title">
              {this.props.productConfiguration && (
                <div>
                  <div className="header-line-1">
                    {step1.getHeaderLine1(this.props.productConfiguration)}
                  </div>
                  <div className="header-line-2">
                    <div>
                      {step1.getHeaderLine2_A(this.props.productConfiguration)}
                      &nbsp;
                    </div>
                    <div>
                      {step1.getHeaderLine2_B(this.props.productConfiguration)}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {showHeaderActions && (
              <div className="flextable-item">
                <div className="header-buttons">
                  {isFromStep3 && this.context.goBackToStep2 && (
                    <Button
                      color="secondary"
                      className="m-1"
                      onClick={() => this.context.goBackToStep2()}
                    >
                      Back to Step 2
                    </Button>
                  )}
                  <Button
                    color="success"
                    className="m-1"
                    onClick={() => this.props.onContinue(true)}
                    disabled={preparingForReview}
                  >
                    {isAmiPriceLookupMode && 'Done'}
                    {!isAmiPriceLookupMode && (
                      <Fragment>
                        {preparingForReview ? 'Reviewing' : 'Review Quote'}
                      </Fragment>
                    )}
                    <Spinner show={preparingForReview} />
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
